import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FacadeService } from 'src/app/core/services/facade.service';
import { CompetencesElementaires } from 'src/app/shared/enums/competence.enum';
import { Parcours } from 'src/app/shared/models/services-aide-emploi/parcours';

@Component({
	selector: 'app-dashboard-ocashe-appointments',
	templateUrl: './dashboard-ocashe-appointments.component.html',
	styleUrl: './dashboard-ocashe-appointments.component.scss'
})
export class DashboardOcasheAppointmentsComponent implements OnInit {
	listAppointments: Parcours[] = [];
	manyNewAppointments: boolean = false;

	constructor(private router: Router, private facade: FacadeService) {}

	ngOnInit(): void {
		this.loadNewAppointments();
	}

	loadNewAppointments() {
		this.facade.parcoursService.getParcours().subscribe({
			next: (appointments) => {
				this.listAppointments = appointments;
				this.manyNewAppointments = this.listAppointments.length > 1;
			},
			error: (e) => {}
		});
	}

	formatTime(minutes: number): string {
		const hours = Math.floor(minutes / 60);
		const mins = minutes % 60;
		return `${hours}:${mins.toString().padStart(2, '0')}`;
	}

	navigateToAddForm(appointment: any) {
		this.router.navigate(['/gestion/formations/add'], {
			queryParams: {
				date: new Date(appointment.date).toISOString(), // formate la date en 'YYYY-MM-DD'
				startTime: appointment.startTime,
				endTime: appointment.endTime,
				missionType: null,
				skill: CompetencesElementaires.PRESCRIPTION.name,
				id: appointment.id
			}
		});
	}
}
